import React from 'react'
import ReactDOM from 'react-dom/client'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Missing #root element')

const root = ReactDOM.createRoot(rootElement)

// IMPORTANT ROUTING CONTRACT:
//   / and every non-/admin path => public BBN Store website
//   /admin and /admin/*         => BBN admin console
// Admin feature navigation stays inside /admin using hashes, e.g. /admin#/products.
const pathname = (window.location.pathname || '/').replace(/\/{2,}/g, '/').toLowerCase()
const isAdminRoute = pathname === '/admin' || pathname.startsWith('/admin/')

async function renderPublicSite() {
  const [{ default: App }] = await Promise.all([
    import('./site/App.jsx'),
    import('./site/site.css'),
  ])
  document.title = 'BBN Store — Build Better. Live Stronger.'
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

async function renderAdmin() {
  const { default: AdminApp } = await import('./admin/AdminApp.jsx')
  document.title = 'BBN Admin'
  root.render(<AdminApp />)
}

if (isAdminRoute) {
  renderAdmin().catch((error) => {
    console.error(error)
    root.render(<pre style={{ color: 'white', background: '#05080d', minHeight: '100vh', padding: 24 }}>Admin failed to load: {String(error?.message || error)}</pre>)
  })
} else {
  renderPublicSite().catch((error) => {
    console.error(error)
    root.render(<pre style={{ color: 'white', background: '#05080d', minHeight: '100vh', padding: 24 }}>Website failed to load: {String(error?.message || error)}</pre>)
  })
}
